export const DEFAULT_FORM_VALUES = {
  campaignDatetime: '',
  delivered: 30,
  failed: 0,
  file: null,
  media: null,
  message: '',
  pending: 0,
  rate: 1000,
  read: 20,
  sent: 60
};

export const RATIO_FIELDS = [
  { key: 'pending', label: 'Pending' },
  { key: 'sent', label: 'Sent' },
  { key: 'delivered', label: 'Delivered' },
  { key: 'read', label: 'Read' },
  { key: 'failed', label: 'Failed' }
];
